
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { MapPin, Share2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const HeroSection = () => {
  const { t, language } = useLanguage();
  const isMobile = useIsMobile();
  
  return (
    <section className="w-full bg-white py-0 md:py-0 relative overflow-hidden">
      <div className="container px-0 md:px-0 mx-auto py-0 relative">
        {isMobile ?
          // Mobile layout - Updated with white gradient and black text
          <div className="flex flex-col">
            <div className="absolute z-10 top-0 left-0 h-full w-full px-4 flex flex-col justify-end pb-8 py-[11px]">
              {/* Changed gradient to white for better visibility with black text */}
              <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-white/90 via-white/70 to-transparent py-0 my-0"></div>
              
              <h1 className="tracking-tight text-gray-900 mb-2 relative z-10 text-3xl font-extrabold">
                {language === 'en' ? t('home.heroTitle') : '加拿大真實租屋經驗'}
              </h1>
              <p className="text-sm mb-5 relative z-10 text-gray-600">
                {language === 'en' ? t('home.heroSubtitle') : '過來人親身分享，讓你租得安心又省心'}
              </p>
              <div className="flex flex-row space-x-3 relative z-10">
                <Link to="/reviews" className="flex-1">
                  <Button variant="default" size="sm" className="bg-orange-600 hover:bg-orange-500 text-slate-50 w-full font-medium text-sm">
                    <MapPin className="mr-2 h-3 w-3" />
                    {language === 'en' ? t('home.viewReviews') : '查看租客經驗'}
                  </Button>
                </Link>
                <Link to="/submit" className="flex-1">
                  <Button variant="outline" size="sm" className="border border-gray-300 bg-white/90 hover:bg-gray-50 w-full font-medium text-sm">
                    <Share2 className="mr-2 h-3 w-3" />
                    {language === 'en' ? "Share Experience" : '我要分享'}
                  </Button>
                </Link>
              </div>
            </div>
            <div className="w-full h-[540px]">
              <img alt="租屋體驗分享" className="w-full h-full object-cover object-center" src="https://cwuqmrrfvwddicutkrcc.supabase.co/storage/v1/object/public/mainpage//1746232326988.jpg" />
            </div>
          </div> :
          // Desktop layout - Expanded image height
          <div className="hidden md:grid grid-cols-12 h-[580px] w-full">
            {/* 左側空白 */}
            <div className="col-span-2"></div>
            {/* 文字區塊 */}
            <div className="col-span-4 flex flex-col justify-center">
              <h1 className="lg:text-5xl tracking-tight text-gray-900 mb-6 text-4xl font-extrabold">
                {language === 'en' ? t('home.heroTitle') : '加拿大真實租屋經驗'}
              </h1>
              <p className="text-lg text-gray-600 mb-8 max-w-lg">
                {language === 'en' ? t('home.heroSubtitle') : '過來人親身分享，讓你租得安心又省心'}
              </p>
              <div className="flex flex-row gap-4">
                <Link to="/reviews">
                  <Button variant="default" size="lg" className="bg-orange-600 hover:bg-orange-500 text-slate-50 px-[26px] font-medium text-base">
                    <MapPin className="mr-2 h-4 w-4" />
                    {language === 'en' ? t('home.viewReviews') : '查看租客經驗'}
                  </Button>
                </Link>
                <Link to="/submit">
                  <Button variant="outline" size="lg" className="border-2 border-gray-300 hover:bg-gray-50 font-medium text-base px-[26px]">
                    <Share2 className="mr-2 h-4 w-4" />
                    {language === 'en' ? "Share Experience" : '我要分享'}
                  </Button>
                </Link>
              </div>
            </div>
            {/* 中間空白 */}
            <div className="col-span-2"></div>
            {/* 圖片區塊 */}
            <div className="col-span-4 flex items-center justify-center bg-transparent">
              <img alt={language === 'en' ? "Rental Experiences" : "租屋體驗分享"} className="w-full h-full object-contain object-center" src="https://cwuqmrrfvwddicutkrcc.supabase.co/storage/v1/object/public/mainpage//1746232326988.jpg" />
            </div>
          </div>
        }
      </div>
    </section>
  );
};

export default HeroSection;
